export default __webpack_public_path__ + "static/Red_Gem-a9bfc6f61a77f45db1336d4d397f15b2.png";